import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLogin: false,
        luyou: 1,
        userInfo: {},
        nCount: 0,
        report: "",
        api: 'https://pblyt.cocorobo.cn/api/pbl/',
        socket: "https://poll.cocorobo.cn",
        // socket: "http://localhost:1473",
        // api: 'http://localhost:7222/api/pbl/',
    },

    mutations: {
        update(state, [key, value]) {
            state[key] = value;
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/config/config.js